/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useContext, useRef } from "react";
import { XIcon } from "@heroicons/react/solid";
import { useNavigate } from "react-router-dom";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { v4 as uuidv4 } from "uuid";
import Context from "../context/context";
import { openDB } from "idb";
import { PlusIcon } from "@heroicons/react/solid";
import axios from "axios";
import logoUPI from "../images/UPI.png";
import spinner from "../images/spinner.svg";
import { CancelRounded } from '@mui/icons-material';
import styles from '../css/ReferenceScheme.module.css'
import QRCode from "react-qr-code";
import Lottie from 'lottie-react';
import checkAnimation from '../images/animations/checkAnimation.json'
import errorAnimation from '../images/animations/errorAnimation.json'
import { defaultPaymentAlert } from "./PaymentModesForm";

export default function PaymentPopup({
  isPaymentOptionOpen, setPaymentOptionOpen,
  customerInfo, setCustomerInfo,
  createJson, new_kotOrder, new_order,
  printKotInvoice, handleInvoicePrint, containerStyle
}) {

  const { orderProps, amount: billAmount } = isPaymentOptionOpen
  const Navigate = useNavigate();
  const context = useContext(Context);

  const page = window.location.pathname;
  const search = window.location.search;
  const [MoneyOpts, setMoneyOpts] = useState(null);
  const [hitCounts, setHitCounts] = useState(null);
  const [paymentInfo, setPaymentInfo] = useState({});

  const [cashAmount, setCashAmount] = useState(page.includes("/report-orders") ? 0 : billAmount);
  const [paymentModes, setPaymentModes] = useState(null);
  const [totalAmount, setTotalAmount] = useState(0);
  const [cashReceived, setCashReceived] = useState(0);
  const [isInvoiceActive, setIsInvoiceActive] = useState(false);
  const [domState, setDomState] = useState("");
  const [isContentReseted, setisContentReseted] = useState(false);
  const returnedAmount = cashReceived - billAmount > 0 ? cashReceived - billAmount : 0;

  const [payModeAmount, setPayModeAmount] = useState([]);
  const [optPopup, setOptPopup] = useState(false);
  const [UPISetup, setUPISetup] = useState({ status: 1, text: defaultPaymentAlert });

  // Import content from context.
  const {
    itemChargesHandlerRef, itemChargesValueRef,
    setForceRenderOrdersPage,
    payment_popup_save_btns_ref,
    putOrdersTimeout, updateUnSync,
    generateCoupons, showWarning
  } = context;

  useEffect(() => {
    const getData = () => {

      customerInfo && console.log("customer details :", customerInfo);
      let DBOpenReq = indexedDB.open("FoodDo", +localStorage.getItem("IDBVersion") || 1);
      DBOpenReq.addEventListener("error", (err) => console.warn(err))
      DBOpenReq.addEventListener("success", (ev) => {
        let tx = ev.target.result.transaction("outlet", "readonly");
        let store = tx.objectStore("outlet");

        let getOutlet = store.getAll();
        getOutlet.onsuccess = (ev) => {
          const outlet = ev.target.result[0]
          const cashDenos = outlet.cash_denominations;

          console.log(cashDenos)
          cashDenos.sort((a, b) => a.sort_order - b.sort_order);
          setMoneyOpts(cashDenos);

          const hitsArray = {};
          cashDenos.forEach((deno, index) => (hitsArray[`${index}`] = 0));
          setHitCounts(hitsArray);
          setUPISetup(outlet?.upi_setup)
        };

        tx = ev.target.result.transaction("payment_modes", "readonly");
        store = tx.objectStore("payment_modes");
        let getPaymentModes = store.getAll();
        getPaymentModes.onsuccess = (ev) => {
          let modes = ev.target.result;

          const filteredModes = modes?.filter((mode) => {
            let outlet_wise = mode.outlet_wise_details.find(outlet => outlet.outlet_uuid === localStorage.getItem("outlet_uuid"));
            if (outlet_wise && outlet_wise.status === "1") return mode;
            else return '';
          });

          console.log("filtered modes-------------------", filteredModes);
          setPaymentModes(filteredModes);
        };
      });
    }
    getData()
  }, []);

  useEffect(() => {
    if (page.includes("/report-orders") && paymentModes && isPaymentOptionOpen.order) {

      const modesObj = {};
      isPaymentOptionOpen.order.payment_details?.forEach(p => {

        let this_mode = paymentModes.find(m => m.payment_mode_uuid === p.payment_mode_uuid);
        if (this_mode?.primary_cash?.toLowerCase() === "y" && this_mode?.payment_mode_name?.toLowerCase()?.includes("cash"))
          setCashAmount(+p.amount)

        modesObj[p.payment_mode_uuid] = +p.amount || 0;
      });

      setCustomerInfo({
        name: isPaymentOptionOpen.order.customer_name,
        number: isPaymentOptionOpen.order.customer_mobile
      })
      setPayModeAmount(modesObj);
    }
  }, [paymentModes])

  function clickHandler(e, id, action) {
    if (cashReceived === 0 && action !== "add") return;
    if (cashAmount === 0 && action === "return") return;

    let currentCount = e.currentTarget.querySelector(".hitCount").innerText;
    currentCount = +currentCount.slice(1, currentCount.length - 1);

    if (action === "decrease" || action === "re-add") {
      if (currentCount === 1) e.currentTarget.classList.remove("greenbtn");
      if (currentCount !== 0)
        e.currentTarget.querySelector(".hitCount").innerText = `(${currentCount - 1
          })`;
    } else {
      e.currentTarget.classList.add("greenbtn");
      e.currentTarget.querySelector(".hitCount").innerText = `(${currentCount + 1
        })`;
    }

    let total;

    if (action === "add") {
      if (isContentReseted === true) {
        setCashReceived(0 + +e.currentTarget.getAttribute("amount-value"));
        total = 0 + +e.currentTarget.getAttribute("amount-value");
        setisContentReseted(false);
      } else {
        setCashReceived(
          cashReceived + +e.currentTarget.getAttribute("amount-value")
        );
        total =
          (+cashAmount || 0) + +e.currentTarget.getAttribute("amount-value");
      }
    } else if (action === "return")
      total = cashAmount
        ? +cashAmount - +e.currentTarget.getAttribute("amount-value")
        : 0;
    else if (action === "decrease" && currentCount !== 0) {
      setCashReceived(
        cashReceived - +e.currentTarget.getAttribute("amount-value")
      );
      total = cashAmount
        ? +cashAmount - +e.currentTarget.getAttribute("amount-value")
        : 0;
    } else if (action === "re-add" && currentCount !== 0)
      total = cashAmount
        ? +cashAmount + +e.currentTarget.getAttribute("amount-value")
        : 0;

    if (total < 0) total = 0;
    setCashAmount(total);
  }

  function setTotal() {
    setTimeout(() => {
      let total = 0;
      const inputs = document.getElementsByClassName("amount-field");
      Array.from(inputs).forEach((input) => {
        console.log(input.value);
        total = total + +input.value;
      });
      console.log("total", total);
      setTotalAmount(total);
    }, 100);
  }

  function resetHitCount() {
    Array.from(document.getElementsByClassName("hitCount")).forEach(
      (element) => {
        element.innerText = "(0)";
        element.parentElement.classList.remove("greenbtn");
      }
    );

    const cashDenos = hitCounts;
    for (const i in cashDenos) {
      cashDenos[i] = 0;
    }
    setHitCounts(cashDenos);
    setCashReceived(0);
    setisContentReseted(true);
  }

  const [payment_details, setPayment_details] = useState(null);

  function paymentSaveHandle() {

    let total = 0;
    let array = [];

    console.log(Array.from(document.getElementsByClassName("amount-field")));
    Array.from(document.getElementsByClassName("amount-field")).forEach(
      (field, i) => {
        console.log(field)
        total += +(field.value);

        if (+(field.value) > 0)
          array.push({
            payment_mode_uuid: field.getAttribute("payment-mode-uuid"),
            amount: +(field.value),
          });
        else if (+totalAmount === 0 && +i === 0) {
          array.push({
            payment_mode_uuid: field.getAttribute("payment-mode-uuid"),
            amount: 0,
          });
        }
      }
    );

    console.log(total, +billAmount);
    if (total === +billAmount) {

      Array.from(document.querySelectorAll(".amount-field")).forEach((i) => i.blur());
      console.log(array);
      setPayment_details(array);
      let filteredPaymentMode = paymentModes?.filter(a => array?.filter(b => a.payment_mode_uuid === b.payment_mode_uuid && b.amount)?.length)?.filter(a => a.maintain_customer_balance === "Y")
      console.log(filteredPaymentMode)

      if (filteredPaymentMode.length && customerInfo.number === '') {
        document.querySelector(".notification-message").innerText = `Mobile Numer Must be present to use ${filteredPaymentMode[0].payment_mode_name}`;
        document.querySelector(".notification-container").classList.add("active-red");
        setTimeout(() => document.querySelector(".notification-container").classList.remove("active-red"), 2000);
      } else {
        console.log("array", array)
        let paymentOptFilter = paymentModes.filter(a => a.maintain_customer_balance === "Y" && +a.outlet_wise_details[0].payment_mode_otp === 1).filter(a => array.filter(b => b.payment_mode_uuid === a.payment_mode_uuid && +b.amount !== 0).length)
        console.log("paymrnts", paymentOptFilter.filter(a => a.optStatus !== 1))
        console.log("paymrnts", array)
        if (paymentOptFilter.filter(a => +a.optStatus !== 1).length) {
          const getOutlet = async () => {
            const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
            const tx = db.transaction("outlet", "readwrite").objectStore("outlet")
            const outlet = await (await tx.getAll())?.[0];
            if (+outlet?.sms_balance === 0) {
              showWarning({
                message: `0 SMS Credits Remaining`,
                classname: 'active-red'
              })
              return
            }
            setPaymentInfo(paymentOptFilter[0])
            setOptPopup(true)
          }
          getOutlet()
        } else {
          setIsInvoiceActive(!isInvoiceActive);
          console.log(isInvoiceActive);
        }
      }
    } else {
      document.querySelector(".notification-message").innerText = "Bill Amount and Payment Amount mismatch";
      document.querySelector(".notification-container").classList.add("active-red");
      setTimeout(() => document.querySelector(".notification-container").classList.remove("active-red"), 2000);
    }
  }

  useEffect(() => {
    setTotal()
  }, [cashAmount])

  function updateContact() {
    let DBOpenReq = indexedDB.open("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    DBOpenReq.addEventListener("error", (err) => console.warn(err));
    DBOpenReq.addEventListener("success", (ev) => {
      let db = ev.target.result;
      let collectionName;
      if (orderProps?.order_status_param === 4) collectionName = "Orders"
      else collectionName = "running_orders"
      let tx = db.transaction(collectionName, "readwrite");
      let store = tx.objectStore(collectionName);

      for (const order_uuid of orderProps?.order_uuids) {
        let getOrderReq = store.get(order_uuid);
        getOrderReq.onsuccess = (ev) => {
          let order = ev.target.result;
          console.log("found order", order);

          if (orderProps?.order_status_param !== 4) order.IsSynched = 0;
          order.customer_mobile = document.getElementById("payment-contact-mobile").value;
          order.customer_name = document.getElementById("payment-contact-name").value;

          console.log(document.getElementById("payment-contact-mobile").value, order.customer_mobile);
          console.log(document.getElementById("payment-contact-name").value, order.customer_name);
          store.put(order);
        }
      };
      setTimeout(() => document.getElementById("suggestions-payment-div").style.display = "none", 300);
    });
  }

  // Show available contact suggestions from customer json.
  function showSuggestions(e) {
    const input = e.target.value.toLowerCase();
    const container = document.getElementById("suggestions-payment-div");
    const detailsArray =
      JSON.parse(sessionStorage.getItem("customer_details")) || [];

    if (input.length > 2 && detailsArray) {
      const id = e.target.id;
      if (id.includes("name")) container.style.justifyContent = "flex-end";
      else container.style.justifyContent = "flex-start";
      container.style.display = "flex";

      let labelsHTML = (
        <div>
          {detailsArray.map((customer) => {
            if (
              customer.customer_mobile &&
              customer.customer_name
            )
              if (
                customer.customer_mobile.includes(input) ||
                customer.customer_name.includes(input)
              )
                if (id.includes("mobile"))
                  return (
                    <label
                      key={Math.random()}
                      className="contact-suggestion"
                      onClick={(e) => details_fill_handler(e)}
                    >
                      <div className="bold" name="customer_mobile">
                        {customer.customer_mobile}
                      </div>
                      <div className="light" name="customer_name">
                        {customer.customer_name}
                      </div>
                    </label>
                  );
                else if (id.includes("name"))
                  return (
                    <label
                      key={Math.random()}
                      className="contact-suggestion"
                      onClick={(e) => details_fill_handler(e)}
                    >
                      <div className="bold" name="customer_name">
                        {customer.customer_name}
                      </div>
                      <div className="light" name="customer_mobile">
                        {customer.customer_mobile}
                      </div>
                    </label>
                  );
                else return ''
              else return ''
            else return ''
          })}
        </div>
      );

      console.log(labelsHTML);
      setDomState(labelsHTML);
    } else container.style.display = "none";
  }

  // Fill selected contact details automatically in target input fields
  function details_fill_handler(e) {
    const name = e.target.parentNode.querySelector(
      '[name="customer_name"]'
    ).innerText;
    const number = e.target.parentNode.querySelector(
      '[name="customer_mobile"]'
    ).innerText;

    setCustomerInfo({ name, number });
  }

  const AddCustomerReport = async (order) => {
    if (order.customer_mobile !== "") {
      const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
      const tx = db.transaction("customer", "readwrite").objectStore("customer");
      let customers = await tx.getAll()
      let filterCustomers = await customers?.filter(item => order.customer_mobile === item.customer_mobile)
      if (filterCustomers?.length === 0) {
        const customerArray = await tx.getAll()
        console.log("-----------------filterCustomers?.length === 0", customerArray)
        let customerObj = {
          IDENTIFIER: order.customer_mobile,
          customer_mobile: order.customer_mobile,
          customer_item_special: [],
          customer_payment_details: [],
          customer_self_address: [],
          outlet_wise_customer_details: [{
            outlet_uuid: localStorage.getItem("outlet_uuid"),
            customer_name: order.customer_name,
            customer_outlet_address: "",
            customer_visits: 1,
            created_at: Date.now()
          }]
        }
        await tx.put(customerObj)

      } else {
        console.log("-----------------filterCustomers?.length === 1")
        let nameFiltered = await filterCustomers?.filter(item => order.customer_mobile === item.outlet_wise_customer_details[0].customer_name)

        filterCustomers.map(async (item1) => {
          let existingItem = {
            ...item1,
            IDENTIFIER: item1.customer_mobile,
            customer_payment_details: [],
            outlet_wise_customer_details: [
              {
                ...item1.outlet_wise_customer_details[0],
                customer_name: nameFiltered?.length === 0 ? order.customer_name : item1.customer_name,
                customer_visits: (parseFloat(item1?.outlet_wise_customer_details[0]?.customer_visits) || 0) + 1
              }
            ]
          }
          console.log("-----------------existingItem", existingItem)
          await tx.put(existingItem)
        })
      }
      return true
    } else { return true }
  }

  const paymentProcessing = async (order, db, invoiceCopiesText, callback, paymentDetails, brand_uuid, order_uuid, updatePaymentDetail) => {

    let tx = db.transaction("outlet", "readwrite");
    let store = tx.objectStore("outlet");
    let outlet = (await store.getAll())[0];

    // console.log(order, orderProps.order_uuid, outlet)
    if (search?.includes('edit')) {
      let response = await createJson(order, outlet);
      console.log(response);
      order = response.json;
      outlet = response.outlet;

      tx = db.transaction("outlet", "readwrite");
      store = tx.objectStore("outlet");
      store.put(outlet);
    }

    console.log("------------------------------------------", order, outlet);
    console.log("order before updating", order);

    if (isPaymentOptionOpen.saveNpayment) {

      if (order) order = await new_kotOrder({ json: order, outlet, time: Date.now(), buttonStatus: 1 })
      else order = await new_order({ outlet, buttonStatus: 1, brand_uuid, order_uuid })

      let unplacedSeatOrder = JSON.parse(localStorage.getItem("unplaced_orders"));
      if (unplacedSeatOrder) {
        console.log('clearing seat unplaced order from local')
        unplacedSeatOrder = unplacedSeatOrder.filter((i) => i.order_uuid !== order.order_uuid);
        localStorage.setItem("unplaced_orders", JSON.stringify(unplacedSeatOrder));
      }

      await outlet.invoice_series.forEach((s) => {
        if (s.user_uuid === localStorage.getItem("user_uuid")) {
          s.next_order_number = +s.next_order_number + 1
          s.last_used_at = Date.now();
          if (+s.next_kot_number < +s.kot_end)
            s.next_kot_number = +s.next_kot_number + 1;
          else s.next_kot_number = +s.kot_start;
        }
      });

      tx = db.transaction("outlet", "readwrite");
      store = tx.objectStore("outlet");
      store.put(outlet);
    }

    itemChargesValueRef.current = [];
    await itemChargesHandlerRef.current.click();

    if (orderProps?.order_status_param !== 4) order.IsSynched = 0;
    let order_payment_details = order?.payment_details || [];
    let collectedAmt = 0

    if (+order.order_total > 0) {
      console.log('--------------------------------')
      let payModesdata = await paymentDetails?.map(payMode => {
        console.log('this mode: ', payMode)
        if (+payMode.amount <= 0) return console.log('returned');
        const remaining = +order.order_total - collectedAmt
        let deducted = 0
        if (payMode?.amount >= remaining) deducted = remaining
        else deducted = payMode.amount

        order_payment_details.push({ ...payMode, amount: deducted });
        collectedAmt += deducted
        console.log('remaining: ', `${+order.order_total} - ${collectedAmt}`)
        return { ...payMode, amount: +payMode.amount - deducted }
      })
      console.log('--------------------------------')
      updatePaymentDetail(payModesdata)
    } else {
      order_payment_details.push({
        payment_mode_uuid: paymentModes?.find(i => i.primary_cash === 'Y')?.payment_mode_uuid,
        amount: collectedAmt
      })
      updatePaymentDetail()
    }

    console.log(order_payment_details)
    order.payment_total = collectedAmt;
    order.payment_details = order_payment_details;
    order.payment_at = Date.now();
    order.payment_by_user_uuid = localStorage.getItem("user_uuid");
    order.payment_status = 1;

    let object = {
      at: Date.now(),
      copies: invoiceCopiesText,
      user_uuid: localStorage.getItem("user_uuid"),
    };

    order.invoice_prints = order.invoice_prints || [];
    await order.invoice_prints.push(object);

    if (order.payment_status === 1 || order.payment_status === 2 || order.payment_status === 3)
      if (order.preparation_status === 1 || order.preparation_status === 2)
        if (!order.delivery_status || order.delivery_status !== 0)
          order.order_status = 4;
        else order.order_status = 3;
      else order.order_status = 3;
    else order.order_status = 3;

    console.log(payment_details);
    console.log(order.seat_uuid);
    console.log("updated order", order);
    if (+order.order_type !== 0 && +order.order_status === 4) {
      let element = document.getElementById(order.order_uuid)?.parentElement?.nextSibling?.lastChild
        || document.getElementById(order.order_uuid)?.parentElement?.previousSibling?.lastChild;
      sessionStorage.setItem('nonseat-order-id', element?.id)
    }

    if ((+order.order_status !== 4 && !search?.includes('edit')) || (+order.preparation_status !== 1 && search?.includes('edit'))) {

      tx = db.transaction("running_orders", "readwrite");
      store = tx.objectStore("running_orders");
      console.log("order is not complete");
      store.put(order);

      if (+order.order_status < 4 && +order.order_type === 0) {
        let onseat_orders = JSON.parse(localStorage.getItem("onorder_seats"));
        onseat_orders = await onseat_orders?.filter(i => i.uuid !== order.order_uuid)

        let object = {
          seat_uuid: order.seat_uuid,
          created_at: order.created_at,
          price: order.order_total,
          title: order.local_order_id,
          uuid: order.order_uuid,
          invoiced: 1
        };

        onseat_orders.push(object);
        localStorage.setItem("onorder_seats", JSON.stringify(onseat_orders));
      }

      callback && callback(order)
      return
    }

    let unplaced_nonseat_orders = (JSON.parse(localStorage.getItem("unplaced-nonseat-order")))?.filter(i => i.order_uuid !== order.order_uuid) || [];
    localStorage.setItem("unplaced_orders", JSON.stringify(unplaced_nonseat_orders));

    let extended_nonseat_orders = (JSON.parse(localStorage.getItem("extended-nonseat-order")))?.filter(i => i.order_uuid !== order.order_uuid) || [];
    localStorage.setItem("unplaced_orders", JSON.stringify(extended_nonseat_orders));

    let unplacedSeatOrder = (JSON.parse(localStorage.getItem("unplaced_orders")))?.filter((i) => i.order_uuid !== order.order_uuid);
    localStorage.setItem("unplaced_orders", JSON.stringify(unplacedSeatOrder));

    console.log("order is complete");
    tx = db.transaction("running_orders", "readwrite");
    store = tx.objectStore("running_orders");

    console.log(order)
    store.delete(order.order_uuid);

    order.IDENTIFIER = order.order_uuid;
    order.completed_at = Date.now();
    delete order.IsSynched;

    if (order.SRC && order.UPDATED_AT) putOrdersTimeout()
    else delete order.Sync_Type

    let order_doc_status;
    tx = db.transaction("Orders", "readwrite");
    store = tx.objectStore("Orders");

    if (search?.includes('edit')) {
      store.put(order);
      order_doc_status = "order-edit:";
    }
    else {
      store.add(order);
      localStorage.setItem("temp_order_id", order.order_uuid)
      order_doc_status = "order-new:";
    }

    if (order?.customer_mobile && !search?.includes('edit') && order.coupons?.length > 0) {
      let scheme_tx = db.transaction("scheme", "readwrite").objectStore("scheme");
      let schemes = await scheme_tx.getAll();
      schemes = schemes.filter(scheme => +scheme.scheme_status === 1);

      tx = db.transaction("unsynced_files", "readwrite");
      store = tx.objectStore("unsynced_files");

      let coupon_tx = db.transaction("coupon", "readwrite").objectStore("coupon");
      let coupons = await coupon_tx.getAll();

      const coupons_docs = coupons.filter(i => order.coupons.find(j => j.coupon_code === i.coupon_code))
      let transactions = [];

      const generateTxnDoc = async (person, customer_mobile, scheme_uuid, coupon_uuid) => {
        console.log({ person, customer_mobile, scheme_uuid, coupon_uuid })
        let amount;
        if (person.discount_type === 'P') {
          amount = await +order.order_total * (+person.value / 100)
          if (+person.max_limit && +person.max_limit < amount) amount = +person.max_limit;
        }
        else amount = await +person.value

        transactions = await [...transactions, {
          type: 'PROMO',
          narration: `Added: ${scheme_uuid}`,
          coupon_uuid: coupon_uuid,
          voucher_uuid: uuidv4(),
          payment_details: [{
            payment_mode_uuid: person.paymode_uuid,
            amount
          }],
          customer_mobile,
          outlet_uuid: order.outlet_uuid,
          timestamp: Date.now(),
          working_day: order.working_day,
        }]
      }

      console.log('applied coupons : ', coupons_docs)
      for (let count = 0; count < coupons_docs.length; count++) {
        const coupon = await coupons_docs[count];
        const order_coupon = await order?.coupons?.find(j => j.coupon_code === coupon.coupon_code)
        const scheme = await schemes.find(i => i.scheme_uuid === coupon.scheme_uuid)

        const getPerson = (collection, person_index) => collection?.find(i => +i.person_index === +person_index)

        // For other persons
        console.log({ order_coupon, scheme, coupon })
        if (+order_coupon?.current_person_index > 2) {
          const person = getPerson(scheme?.other_persons, order_coupon?.current_person_index)
          if (person.paymode_uuid !== 'D')

            await generateTxnDoc(person, order.customer_mobile, scheme?.scheme_uuid, coupon?.coupon_uuid)
          console.log({ person })

          for (const eligible_person_detail of person?.commission_distribution) {

            let eligible_person;
            let coupon_person_detail;

            console.log({ eligible_person_detail })

            if (+eligible_person_detail?.person_index === 1 && scheme.first_person.paymode_uuid) {
              eligible_person = scheme.first_person;
              coupon_person_detail = { customer_mobile: coupon.customer_mobile }
            }
            else if (+eligible_person_detail?.person_index === 2) {
              eligible_person = scheme.second_person;
              coupon_person_detail = getPerson(coupon?.persons_details, eligible_person_detail?.person_index)
            }
            else if (+eligible_person_detail?.person_index > 2) {
              eligible_person = getPerson(scheme?.other_persons, eligible_person_detail?.person_index)
              coupon_person_detail = getPerson(coupon?.persons_details, eligible_person_detail?.person_index)
            }
            else continue;

            await generateTxnDoc({
              ...eligible_person,
              discount_type: eligible_person_detail?.discount_type,
              value: eligible_person_detail?.commission
            }, coupon_person_detail?.customer_mobile,
              scheme?.scheme_uuid, coupon?.coupon_uuid
            )
          }
        } else if (+order_coupon?.current_person_index === 2 && scheme.second_person.paymode_uuid !== 'D') {
          await generateTxnDoc(scheme.second_person, order.customer_mobile, scheme?.scheme_uuid, coupon?.coupon_uuid)
          if (scheme.first_person.paymode_uuid && +scheme.first_person.value)
            await generateTxnDoc(scheme.first_person, coupon.customer_mobile, scheme?.scheme_uuid, coupon?.coupon_uuid)
        }
      }

      console.log('transactions : ', transactions)
      store = db.transaction("unsynced_files", "readwrite").objectStore("unsynced_files");
      transactions?.forEach(doc => store.put({
        ...doc,
        BACKUP: 0,
        IDENTIFIER: `transaction-new:${doc.voucher_uuid}`
      }))
    }

    tx = db.transaction("unsynced_files", "readwrite");
    store = tx.objectStore("unsynced_files");

    let putReq = store.put({ ...order, IDENTIFIER: `${order_doc_status}${order.order_uuid}`, BACKUP: 0 });
    putReq.then(updateUnSync);

    AddCustomerReport(order).then(res => {

      if (page !== "/orders" && +order.order_type === 0 && (!orderProps?.order_status_param || +orderProps?.order_status_param < 4)) {
        console.log("deleting order from on orders seats")
        let onorder_seats = JSON.parse(localStorage.getItem("onorder_seats")) || [];
        onorder_seats = onorder_seats?.filter((seatOrder) => seatOrder.seat_uuid !== order.seat_uuid);
        localStorage.setItem("onorder_seats", JSON.stringify(onorder_seats));
      }
      else if (+order.order_type !== 0) {
        // Clear order object in local storage when data is removed from state
        let unplaced_orders = JSON.parse(localStorage.getItem("unplaced-nonseat-order"));
        if (unplaced_orders) {
          console.log('clearing nonseat unplaced order from local')
          unplaced_orders = unplaced_orders.filter((i) => {
            if (i.id !== order.order_uuid) return i;
            else return null
          });
          localStorage.setItem("unplaced-nonseat-order", JSON.stringify(unplaced_orders));
        }
      }
    })
    callback && callback(order);
  }

  const paymentInvoiceHandler = async (e, num, ebill, debug_print) => {

    if (!payment_details) return;

    let order
    if (page.includes("/report-orders") && isPaymentOptionOpen.order) {

      let db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
      let tx = db.transaction("Orders", "readwrite");
      let store = tx.objectStore("Orders");

      order = isPaymentOptionOpen.order;

      let object = {
        at: Date.now(),
        copies: e.target.innerText,
        user_uuid: localStorage.getItem("user_uuid"),
      };

      order.customer_mobile = customerInfo.number
      order.payment_total = order.order_total;
      order.payment_details = payment_details;
      order.invoice_prints = order.invoice_prints || [];
      order.invoice_prints.push(object);

      await store.put(order);
      console.log(order);
      isPaymentOptionOpen.callback(order);
      setPaymentOptionOpen({ status: false })
      return;
    }

    let paymentDetails = payment_details;
    let placedOrders = [];
    let processCount = 0;

    const callback = async order_json => {
      console.log('process payment count:', processCount)
      placedOrders = [...placedOrders, order_json];

      const coupons_messages = await generateCoupons(db, order_json?.order_uuid, order_json?.customer_mobile);
      if (handleInvoicePrint && num) await handleInvoicePrint({ num, ebill, debug_print, order_json, coupons_messages })

      if (++processCount !== orderProps?.order_uuids?.length) return;
      sessionStorage.setItem("is-payment-popup", false);

      setTimeout(() => {
        setPaymentOptionOpen({ status: false });
        if (page.includes('/page2') && !search?.includes('edit')) return Navigate(sessionStorage.getItem('selected-page'));
        else if (page.includes('/page2') && search?.includes('edit')) return Navigate(-1);
        else if (page.includes("/orders")) setForceRenderOrdersPage(uuidv4() + uuidv4());
        else if (page.includes("/page1")) orderProps.refreshDashboard();

        let processedOrderIDs = [];
        const printKOT = order => {
          if (!order) return;
          processedOrderIDs = [...processedOrderIDs, order.order_uuid];
          const callback = () => {
            console.log({ placedOrders })
            if (processedOrderIDs?.length < placedOrders?.length)
              printKOT(placedOrders?.filter(i => !placedOrders.includes(i.order_uuid))?.[0])
          }
          printKotInvoice(+order.order_kot_details[order.order_kot_details.length - 1].kot, order, callback)
        }

        if (+sessionStorage.getItem('kot_type') === 2 && isPaymentOptionOpen.kotOption) printKOT(placedOrders?.[0])
        return Navigate(page);
      }, 200);
    }

    let db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    let checked_order_ids = []

    const performOrderOps = async order_uuid => {
      // alert(order_uuid)
      console.log('order ops called for id:', order_uuid)
      console.log("payment details", paymentDetails)
      checked_order_ids.push(order_uuid);
      let collectionName = orderProps?.order_status_param === 4 ? "Orders" : "running_orders";
      let order = await (db.transaction(collectionName, "readonly").objectStore(collectionName)).get(order_uuid);
      const brand_uuid = order?.brand_uuid || orderProps?.brand_orders.find(i => i.order_uuid === order_uuid).brand_uuid
      await paymentProcessing(order, db, e.target.innerText, callback, paymentDetails, brand_uuid, order_uuid, updatePaymentDetail);
    }

    const updatePaymentDetail = usedPayMode => {
      if (usedPayMode)
        paymentDetails = paymentDetails?.map(i => {
          const doc = usedPayMode?.find(j => j.payment_mode_uuid === i.payment_mode_uuid)
          if (doc) return doc;
          else return i;
        })?.filter(i => +i.amount > 0)
      if (checked_order_ids?.length === orderProps?.order_uuids?.length) return;
      performOrderOps(orderProps?.order_uuids?.filter(id => !checked_order_ids?.includes(id))?.[0])
    }
    performOrderOps(orderProps?.order_uuids?.[0])
  }

  let payment_field_index = -1;
  function clearField(e) {
    console.log(e.currentTarget.previousSibling)
    const name = e.currentTarget.previousSibling.getAttribute('mode-name')

    e.currentTarget.previousSibling.value = 0;
    if (name.toLowerCase().includes('cash'))
      setCashAmount(0);
    setTotal();
  }

  const [UPIState, setUPIState] = useState({
    txn: { amount: 0, txnId: '' }, popup: false
  })

  const checkOrderUPITxn = async () => {
    if (+UPISetup?.status === 0) return;
    setUPIState(doc => ({ ...doc, verifying: true }))
    const res = await axios.post('https://api.myfooddo.com/upi_payments/order-txn-status', {
      order_uuid: orderProps?.order_uuids?.[0],
      amount: totalAmount,
      outlet_uuid: localStorage.getItem('outlet_uuid')
    });
    console.log(res.data)
    if (!res?.data?.succeed) return setUPIState(doc => ({ ...doc, verifying: false }));
    setUPIState(doc => ({ ...doc, txn: res.data, verifying: false, popup: false }))
    setCashAmount(0)
    setTotal()
  }

  useEffect(checkOrderUPITxn, [])

  return (
    <div className="paymentdiv" style={containerStyle || { width: "100vw", left: "-100px", zIndex: "99" }} >
      <div className="paymentContainer">
        <h1>Payment</h1>
        <XIcon
          onClick={() => {
            setPaymentOptionOpen({ status: false });
            sessionStorage.setItem("is-payment-popup", false);
          }}
          className="closebtn"
        />
        <div className="div6">
          <div className="paybils">
            <div className="paycustomerdetails">
              <div className="detailsboxa">
                <input
                  type="text"
                  id="payment-contact-mobile"
                  value={customerInfo.number}
                  onChange={(e) => {

                    if (customerInfo.number === "+91-" && e.target.value.length < 4) {
                      e.target.value = "";
                      setCustomerInfo({ ...customerInfo, number: "" });
                      return e.preventDefault();
                    }

                    var patt = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s./0-9]*$/g;
                    if (!e.target.value || patt.test(e.target.value)) {
                      setCustomerInfo({
                        ...customerInfo,
                        number: "+91-" + e.target.value.replaceAll("+91-", ""),
                      });
                      showSuggestions(e);
                    }
                  }}
                  onBlur={() => setTimeout(() => updateContact(), 300)}
                  placeholder="Mobile no."
                />
                <input
                  type="text"
                  id="payment-contact-name"
                  value={customerInfo.name}
                  onChange={(e) => {
                    setCustomerInfo({
                      ...customerInfo,
                      name: e.target.value,
                    });
                    showSuggestions(e);
                  }}
                  onBlur={() => setTimeout(() => updateContact(), 300)}
                  placeholder="Customer Name"
                />
              </div>
              <div id="suggestions-payment-div" style={{ display: "none" }}>
                {domState}
              </div>
              <div className="bilReccit">
                <div className="flexitem">
                  {+UPISetup?.status && <div className="recitebody">
                    <h1 className="paytct"><img src={logoUPI} alt="UPI" width={60} /></h1>
                    <div style={{ position: "relative", marginRight: '20px' }}>
                      <input
                        payment-field-index={++payment_field_index}
                        payment-mode-uuid={'UPI'}
                        className="amount-field selected upi-payment"
                        type="number"
                        mode-name={'UPI'}
                        value={+UPIState?.txn?.amount || 0}
                        onChange={() => { }}
                        disabled={true}
                      />
                      {UPIState?.txn?.txnId ? <div style={{ position: "absolute", color: "green", top: "8px", right: "-20px" }}> <CheckCircleOutlineIcon style={{ fontSize: "15px" }} /></div> : ""}
                      <button className={`upi-pay-btn ${UPIState?.verifying && 'verifying'}`} onClick={() => setUPIState(doc => ({ ...doc, popup: true }))} disabled={!!UPIState?.txn?.txnId || UPIState?.verifying}>
                        {UPIState?.verifying ? <img src={spinner} alt="." width={30} height={30} /> : 'Pay'}
                      </button>
                    </div>
                  </div>}
                  {paymentModes && paymentModes.map((mode, i) => {
                    if (mode.primary_cash === "Y" && mode?.payment_mode_name?.toLowerCase()?.includes("cash")) {
                      return (
                        <div key={i} className="recitebody">
                          <h1 className="paytct">{mode.payment_mode_name}</h1>
                          <div style={{ position: "relative" }}>
                            <input
                              payment-field-index={++payment_field_index}
                              payment-mode-uuid={mode.payment_mode_uuid}
                              className="amount-field selected"
                              type="number"
                              mode-name={mode.payment_mode_name}
                              value={cashAmount}
                              onChange={(e) => {
                                setTotal();
                                setCashAmount(e.target.value);
                              }}
                              onKeyDown={(e) => {
                                if (
                                  e.key === "ArrowUp" ||
                                  e.key === "ArrowDown" ||
                                  e.key === "e"
                                )
                                  e.preventDefault();
                                resetHitCount();
                              }}
                              autoFocus={true}
                              min={0}
                            />
                            <PlusIcon className="field-cross" onClick={e => clearField(e)} />
                            {mode.maintain_customer_balance === "Y" && mode.optStatus === 1 ? <div style={{ position: "absolute", color: "green", top: "8px", right: "-1px" }}> <CheckCircleOutlineIcon style={{ fontSize: "15px" }} /> </div> : ""}
                          </div>
                        </div>
                      );
                    } else {
                      return (
                        <div key={i} className="recitebody">
                          <h1 className="paytct">{mode.payment_mode_name}</h1>
                          <div style={{ position: "relative" }}>
                            <input
                              payment-field-index={++payment_field_index}
                              payment-mode-uuid={mode.payment_mode_uuid}
                              mode-name={mode.payment_mode_name}
                              className="amount-field"
                              type="number"
                              // defaultValue={
                              //   page.includes("/report-orders") && +payModeAmount[mode.payment_mode_uuid]
                              //     ? +payModeAmount[mode.payment_mode_uuid]
                              //     : 0
                              // }
                              defaultValue={page.includes("/report-orders") ? payModeAmount[mode.payment_mode_uuid] : 0}
                              onKeyDown={(e) => {
                                if (
                                  e.key === "ArrowUp" ||
                                  e.key === "ArrowDown" ||
                                  e.key === "e"
                                )
                                  e.preventDefault();
                              }}
                              onChange={(e) => setTotal()}
                              min={0}
                            />
                            <PlusIcon className="field-cross" onClick={e => clearField(e)} />
                            {mode.maintain_customer_balance === "Y" && mode.optStatus === 1 ?
                              <div
                                style={{ position: "absolute", color: "green", top: "8px", right: "-1px" }}
                              >
                                <CheckCircleOutlineIcon style={{ fontSize: "15px" }} />
                              </div>
                              : ""
                            }

                          </div>
                        </div>
                      );
                    }
                  })}
                  {isPaymentOptionOpen?.order?.payment_details?.find(i => i.payment_mode_uuid === 'UPI') &&
                    <div className="recitebody">
                      <h1 className="paytct">UPI</h1>
                      <div style={{ position: "relative" }}>
                        <input
                          payment-field-index={++payment_field_index}
                          payment-mode-uuid={'UPI'}
                          className="amount-field selected"
                          type="number"
                          mode-name={'UPI'}
                          value={isPaymentOptionOpen?.order?.payment_details?.find(i => i.payment_mode_uuid === 'UPI')?.amount}
                          onChange={() => { }}
                          onKeyDown={(e) => {
                            if (
                              e.key === "ArrowUp" ||
                              e.key === "ArrowDown" ||
                              e.key === "e"
                            )
                              e.preventDefault();
                            resetHitCount();
                          }}
                          style={{ marginRight: '20px' }}
                        />
                      </div>
                    </div>}
                </div>
              </div>
            </div>
            <div className="paybilamounts">
              <div className="paybilamountstopBtn">
                <button className="bilamnt">
                  {billAmount || 0} <span>Bill Amount</span>
                </button>
                <button className="recieved">
                  {cashReceived} <span>Cash Received</span>
                </button>
                <button className="return">
                  {returnedAmount} <span>Return</span>
                </button>
              </div>
              <div className="paybilamountsOptionsbox">
                <div className="paybilamountsOptions">
                  {MoneyOpts &&
                    MoneyOpts.map((element, index) => {
                      return (
                        <button
                          key={element._id}
                          amount-value={element.value}
                          onClick={(e) => clickHandler(e, index, "add")}
                          onContextMenu={(e) => {
                            e.preventDefault();
                            clickHandler(e, index, "decrease");
                          }}
                        >
                          <span>Rs. {element.title}</span>
                          <span className="hitCount">(0)</span>
                        </button>
                      );
                    })}
                </div>
                <div className="paybilamountsOptions">
                  {MoneyOpts &&
                    MoneyOpts.map((element, index) => {
                      return (
                        <button
                          key={element._id}
                          amount-value={element.value}
                          onClick={(e) => clickHandler(e, index, "return")}
                          onContextMenu={(e) => {
                            e.preventDefault();
                            clickHandler(e, index, "re-add");
                          }}
                        >
                          <span>Rs. {element.title}</span>
                          <span className="hitCount">(0)</span>
                        </button>
                      );
                    })}
                </div>
              </div>
            </div>
          </div>
          <div id="payment-btns-container">
            <div className="paybilamountsBottomBtn" id="payment-total-btnDiv">
              <button className="orange">Total : Rs.{totalAmount}</button>
            </div>
            <div
              className="paybilamountsBottomBtn"
              id="payment-btnDiv"
              onBlur={() => setTimeout(() => setIsInvoiceActive(false), 200)}
              ref={payment_popup_save_btns_ref}
            >
              <button
                className="redbtn"
                id="payment-cancel-btn"
                onClick={() => {
                  setPaymentOptionOpen({ status: false });
                  sessionStorage.setItem("is-payment-popup", false);
                }}
              >
                Cancel
              </button>
              <button
                id="save-and-payment-btn"
                className="greenbtn"
                onClick={paymentSaveHandle}
              >
                Save and Invoice
              </button>
              <div
                className={`invoice-container payment-popup ${isInvoiceActive ? "active" : ""}`}
                id="payment-invoice-container"
                style={isInvoiceActive ? { bottom: "200px" } : {}}
              >
                <button
                  id="payment-popup-invoice-0"
                  onClick={(e) => paymentInvoiceHandler(e)}
                  style={{ cursor: "pointer" }}
                >
                  0
                </button>
                <button
                  id="payment-popup-invoice-1"
                  onClick={(e) => paymentInvoiceHandler(e, 1)}
                  style={{ cursor: "pointer" }}
                >
                  1
                </button>
                <button
                  id="payment-popup-invoice-2"
                  onClick={(e) => paymentInvoiceHandler(e, 2)}
                  style={{ cursor: "pointer" }}
                >
                  2
                </button>
                <button
                  id="payment-popup-invoice-ebill"
                  onClick={(e) => paymentInvoiceHandler(e, 1, true)}
                  style={{ cursor: "pointer" }}
                >
                  eBill
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {optPopup ? <OPTPopup close={() => setOptPopup(false)} setPaymentInfo={setPaymentInfo} paymentInfo={paymentInfo} customerInfo={customerInfo} paymentModes={paymentModes} setPaymentModes={setPaymentModes} /> : ""}
      {UPIState?.popup &&
        <UPIPaymentPOPUP
          close={() => setUPIState(doc => ({ ...doc, popup: false }))}
          amt={totalAmount}
          order_uuid={orderProps?.order_uuids?.[0]}
          showWarning={showWarning}
          UPISetup={UPISetup}
          onPaymentSucceed={txn => {
            setCashAmount(0)
            setUPIState({ txn, popup: false })
            setTotal()
          }}
        />
      }
    </div>
  );
}

const transactions = {};
let txnTimer;
const setTxnTimer = func => {
  clearInterval(txnTimer)
  txnTimer = setInterval(func, 5000)
}

const UPIPaymentPOPUP = ({ close, amt, order_uuid, showWarning, UPISetup, onPaymentSucceed }) => {
  const [amount, setAmount] = useState(amt)
  const [payerVa, setPayerVa] = useState('')
  const [qrLoading, setQrLoading] = useState('')
  const [qrString, setQrString] = useState('')
  const [txnStatus, setTxnStatus] = useState()

  const call = func => func()
  const speakAlert = () => {
    const str = UPISetup?.alert_text?.replace('{AMOUNT}', amount)
    const utterance = new SpeechSynthesisUtterance(str)
    const voice = speechSynthesis.getVoices().find(i => i.lang === "hi-IN")
    utterance.rate = .9;
    utterance.voice = voice;

    if (!voice) return setTimeout(() => call(speakAlert), 500)
    console.log({ str, utterance, voice });
    speechSynthesis.speak(utterance)
  }

  const getQRString = async () => {
    if (+amount < 0 || !+amount) return;
    setQrLoading(true)
    try {
      const res = await axios({
        method: "post",
        url: "https://api.myfooddo.com/upi_payments/qr",
        data: { order_uuid, amount, outlet_uuid: localStorage.getItem('outlet_uuid') }
      })
      console.log(res);
      transactions.qr = await res.data
      setQrString(res.data.qrString)
    } catch (error) {
      console.log({ error })
    }
    setQrLoading(false)
    setTxnTimer(checkTxnStatus)
  }

  useEffect(getQRString, [])
  const initiateTransaction = async () => {

    if (!payerVa?.includes('@')) return speakAlert();
    console.log('initiate transaction...')

    try {
      const res = await axios({
        method: "post",
        url: "https://api.myfooddo.com/upi_payments/collectpay",
        data: { payerVa, order_uuid, amount, outlet_uuid: localStorage.getItem('outlet_uuid') }
      })
      console.log(res)
      if (res.data.onsuccess) showWarning({ message: "Transaction Initialized Successfully!", classname: 'active-green' })
      transactions.collectpay = await res.data
      setTxnTimer(checkTxnStatus)
    } catch (error) {
      console.log({ error })
    }
  }

  const checkTxnStatus = async () => {
    for (const txn of Object.values(transactions)) {
      const res = await axios.post('https://api.myfooddo.com/txnstatus', { merchantTranId: txn.txnId, sendDoc: 'moderate' });
      console.log({ order_txn_status: res?.data })
      if (res?.data?.status === 'SUCCESS') {
        clearInterval(txnTimer)
        setTxnStatus({ status: 1, amount: res.data.Amount, method: txn?.transactionType })
        speakAlert();
        onPaymentSucceed({
          amount: res.data?.Amount,
          txnId: txn.txnId,
        })
      }
      else if (res?.data?.status === 'FAILURE' || res?.data?.status === 'FAIL') {
        clearInterval(txnTimer)
        setTxnStatus({ status: -1, amount: res.data.Amount, method: txn?.transactionType })
      }
    }
  }

  return <div id="upi-payment-popup">
    <div className={styles.scheme_form_popup_container} style={{ overflow: 'hidden' }}>
      <div className={styles.formHead}>
        <h2>UPI Payment</h2>
        <CancelRounded onClick={() => { clearInterval(txnTimer); close() }} className={styles.close} />
      </div>

      <div className={`${styles.scheme_form_container} content`} style={{ padding: '20px', overflow: txnStatus ? 'hidden' : 'auto' }}>
        {!txnStatus?.status
          ? <>
            <div className="inputContainer">
              <label htmlFor="upi-payment-amt">Amount</label>
              <input type="number" id="upi-payment-amt" value={amount || 0} onChange={e => setAmount(e.target.value)} onBlur={getQRString} />
            </div>
            <div className="inputContainer">
              <label htmlFor="upi-payer-vpa">UPI ID</label>
              <input type="text" id="upi-payer-vpa" placeholder="Enter Payer UPI/VA" value={payerVa} onChange={e => setPayerVa(e.target.value)} onBlur={initiateTransaction} />
            </div>
            {qrLoading
              ? <div className="qr-image-container loading"><img src={spinner} alt="loading..." width={64} /></div>
              : <p><QRCode value={qrString} /></p>
            }
          </>
          :
          <>
            <Lottie
              animationData={txnStatus?.status === 1 ? checkAnimation : errorAnimation}
              loop={txnStatus?.status === -1}
              id="animation"
              style={{ width: '250px', height: '407px' }}
            />
            <div style={{ textAlign: 'center' }}>
              <p><b>Rs.{txnStatus?.amount}</b></p>
              <p>Payment {txnStatus?.status === 1 ? 'Successful' : 'Failed'}</p>
              {txnStatus?.status === 1 && <p><i><small>Paid Via UPI Request</small></i></p>}
            </div>
          </>
        }
      </div>
    </div>
  </div>
}

const OPTPopup = ({ close, paymentInfo, customerInfo, setPaymentModes, paymentModes, setPaymentInfo }) => {
  const [message, setMessage] = useState("")
  const [otpValue, setOtpValue] = useState("")
  const otpCountDown = useRef(40);
  const intervalRef = useRef(null);
  const [resendDisabled, setResendDisabled] = useState(true);
  const context = useContext(Context);
  const { showWarning } = context;

  const generateOpt = async () => {

    const otpResponse = await axios({
      url: "https://api.myfooddo.com/customer/generate-otp",
      // url: "http://localhost:5000/customer/generate-otp",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      data: {
        outlet_uuid: localStorage.getItem("outlet_uuid"),
        customer_mobile: customerInfo.number
      },
    })
    console.log(otpResponse.data.status)

    if (otpResponse.data.status !== 1) {
      setMessage(otpResponse.data.message)
    }
    else {
      const smsBalance = otpResponse?.data?.sms_balance
      const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
      const tx = db.transaction("outlet", "readwrite").objectStore("outlet")
      const outlet = (await tx.getAll())?.[0]
      tx.put({ ...outlet, sms_balance: smsBalance })
      if (smsBalance < 30)
        showWarning({
          message: `${smsBalance} SMS Credits Remaining`,
          classname: 'active-orange',
          time: 4000
        })
    }

    clearInterval(intervalRef.current);
    otpCountDown.current = 40;
    setResendDisabled(true);

    intervalRef.current = setInterval(() => {

      if (otpCountDown.current > 1 && document.getElementById("otp-countdown")) {
        otpCountDown.current = otpCountDown.current - 1;
        document.getElementById("otp-countdown").innerText = otpCountDown.current;
      }
      else {
        clearInterval(intervalRef.current);
        setResendDisabled(false);
      }
    }, 1000)
  }

  useEffect(() => {
    generateOpt()
  }, [])

  const verifyOpt = async () => {
    const otpResponse = await axios({
      url: "https://api.myfooddo.com/customer/verify-otp",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      data: { otp: otpValue, customer_mobile: customerInfo.number },
    })
    console.log(otpResponse)
    if (+otpResponse.data.status === 1) {
      clearInterval(intervalRef.current);
      setPaymentModes(paymentModes.map(a => a.maintain_customer_balance === "Y" && +a.outlet_wise_details[0].payment_mode_otp === 1 ? {
        ...a, optStatus: 1
      } : a))
      setPaymentInfo({})
      close()
    }
    if (otpResponse.data.status !== 1) setMessage("Invalid OTP!")
  }

  return (<div className='newCategory'>
    <div className='newCatContainer'>
      <div className='newCatContainer_header'>
        <h2>OTP</h2>
        <XIcon className='closeicon' onClick={() => {
          clearInterval(intervalRef.current)
          close()
        }} />
      </div>
      <div className='newCatContainer2'>
        <div className='cat-inp'>
          <label htmlFor='catname'>Please Enter OTP</label>
          <input
            value={otpValue}
            onChange={(e) => setOtpValue(e.target.value)}
            maxLength={15}
            type='text'
            id='catname'
          />
        </div>
        <div style={{ color: "red" }}>{message}</div>
        <div id="payment-otp-countdown">
          {resendDisabled &&
            <span>
              You can resend OTP in <span id="otp-countdown">{otpCountDown.current}</span> seconds
            </span>}
        </div>

        <div id="otp-btns">
          <button onClick={verifyOpt}>
            Confirm
          </button>

          <button onClick={generateOpt} disabled={resendDisabled}>
            Resend OTP
          </button>
        </div>

      </div>
    </div>
  </div>)
}